import { render, staticRenderFns } from "./CasePrize.vue?vue&type=template&id=89c3ba60&scoped=true&"
import script from "./CasePrize.vue?vue&type=script&lang=js&"
export * from "./CasePrize.vue?vue&type=script&lang=js&"
import style0 from "./CasePrize.vue?vue&type=style&index=0&id=89c3ba60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c3ba60",
  null
  
)

export default component.exports